import * as Yup from "yup";
// const nameRegex = /^[A-Za-z]+$/;
import { isValidPhoneNumber } from "libphonenumber-js";
const nameRegex = /^[a-zA-Z\s]*$/;

export const UserSignUp = Yup.object({
  name: Yup.string()
    .min(2, "First Name must be at least 2 characters long.")
    .max(32, "First Name must be at most 32 characters long.")
    .matches(nameRegex, "First Name must contain only alphabetic characters.")
    .required("Please enter your First Name."),
  lname: Yup.string()
    .min(2, "Last Name must be at least 2 characters long.")
    .max(32, "Last Name must be at most 32 characters long.")
    .matches(nameRegex, "Last Name must contain only alphabetic characters.")
    .required("Please enter your Last Name."),
  email: Yup.string().email().required("Please enter your email."),
  username: Yup.string()
    .min(3, "Username must be at least 3 characters long.")
    .max(32, "Username must be at most 32 characters long.")
    .required("Please choose a username."),
  pass: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and be at least 8 characters long"
    ),
  confirmPass: Yup.string()
    .oneOf([Yup.ref("pass"), null], "Passwords must match")
    .required("Confirm Password is required"),

  phone: Yup.string()
    .required("Please enter your phone number.")
    .test(
      "isValidPhoneNumber",
      "Please enter a valid phone number.",
      function (value) {
        const { country } = this.parent;

        if (!value) return false;
        return isValidPhoneNumber(value, country);
      }
    ),
});

export const LogIn = Yup.object({
  username: Yup.string().required("Email is required"),
  password: Yup.string().min(4).max(32).required("Please enter password."),
});
export const ChangeUserPass = Yup.object({
  oldPassword: Yup.string().required("Old Password is required"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and be at least 8 characters long"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

export const UserProfileInformation = Yup.object({
  name: Yup.string()
    .min(2, "First Name must be at least 2 characters long.")
    .max(32, "First Name must be at most 32 characters long.")
    .matches(nameRegex, "First Name must contain only alphabetic characters.")
    .required("Please enter your First Name."),
  lname: Yup.string()
    .min(2, "Last Name must be at least 2 characters long.")
    .max(32, "Last Name must be at most 32 characters long.")
    .matches(nameRegex, "Last Name must contain only alphabetic characters.")
    .required("Please enter your Last Name."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phone: Yup.string().required("Please enter your phone number."),
});